export default __webpack_public_path__ + "assets/models/9db188b922ae8ac47626d1eb3f806f99.glb";